import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header d-flex flex-row justify-content-between" }
const _hoisted_3 = { class: "btn-toolbar" }
const _hoisted_4 = { class: "form-check form-switch" }
const _hoisted_5 = { class: "card-body small" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = {
  class: "form-floating btn-group col-12",
  id: "com-type-control"
}
const _hoisted_8 = { class: "position-absolute col-10 px-2 d-flex flex-row justify-content-center mt-4 overflow-hidden" }
const _hoisted_9 = { class: "d-flex flex-row align-items-center text-secondary text-truncate" }
const _hoisted_10 = { class: "ms-2" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "dropdown-menu scrollable-menu dropdown-menu-end" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["id"]
const _hoisted_15 = { class: "d-flex" }
const _hoisted_16 = { class: "fw-lighter ps-2" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-12 col-sm-4" }
const _hoisted_19 = {
  key: 0,
  class: "fas fa-exclamation-triangle fa-fw ms-1"
}
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-12 col-sm-8 text-truncate" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-12 col-sm-8" }
const _hoisted_24 = { class: "mt-3" }
const _hoisted_25 = { class: "form-floating" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  class: "input-group-text",
  id: "toCurrency"
}
const _hoisted_28 = { class: "px-4 invalid-feedback warning-feedback text-center" }
const _hoisted_29 = { class: "mt-2" }
const _hoisted_30 = { class: "form-floating" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = { class: "mt-2" }
const _hoisted_33 = { class: "form-floating" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "card-footer d-flex justify-content-center" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = {
  key: 0,
  class: "fas fa-spinner fa-spin ms-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[11] || (_cache[11] = _createElementVNode("span", null, [
        _createElementVNode("i", { class: "fas fa-check-circle fa-fw me-1" }),
        _createTextVNode("Activar Ficha de Pago ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input secondary",
            type: "checkbox",
            role: "switch",
            id: "share-email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.update) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.update]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("form", {
        novalidate: "",
        onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["form-control flex-fill d-flex rounded-0 rounded-start text-center", _ctx.readOnlyClasses]),
              type: "text",
              id: "available-quotes",
              style: {"color":"transparent !important"},
              placeholder: "Tipo",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedQuote.tx_id) = $event)),
              required: ""
            }, null, 2), [
              [_vModelText, _ctx.selectedQuote.tx_id]
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.selectedQuote.address), 1)
              ])
            ]),
            _createElementVNode("button", {
              class: "col-2 btn btn-outline-secondary dropdown-toggle dropdown-toggle-split d-flex justify-content-center align-items-center",
              type: "button",
              "data-bs-toggle": "dropdown",
              "aria-expanded": "false",
              id: "commission-type-button",
              disabled: !_ctx.update
            }, [...(_cache[12] || (_cache[12] = [
              _createElementVNode("span", { class: "visually-hidden" }, "Abrir Lista de Wallets Disponibles", -1)
            ]))], 8, _hoisted_11),
            _createElementVNode("ul", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quotesList, (q) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: q.tx_id,
                  onClick: ($event: any) => (_ctx.selectQuote(q))
                }, [
                  _createElementVNode("button", {
                    class: "dropdown-item ps-2",
                    id: 'item-type-' + q.address
                  }, [
                    _createElementVNode("span", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(q.address), 1)
                    ])
                  ], 8, _hoisted_14)
                ], 8, _hoisted_13))
              }), 128))
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("label", {
              for: "commission-type-input",
              class: "opacity-100"
            }, "Wallets Disponibles", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("label", {
              for: "concept",
              class: _normalizeClass(["col-form-label py-0 fw-bold text-nowrap", { 'text-danger': _ctx.isDate24HoursOld }])
            }, [
              _cache[14] || (_cache[14] = _createTextVNode("Fecha: ", -1)),
              (_ctx.isDate24HoursOld)
                ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["col-12 col-sm-8 -text-nowrap", { 'text-danger': _ctx.isDate24HoursOld }])
          }, _toDisplayString(_ctx.formatDateTimezone(_ctx.selectedQuote.createdDate as Date)), 3)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _cache[15] || (_cache[15] = _createElementVNode("label", {
            for: "concept",
            class: "col-12 col-sm-4 col-form-label py-0 fw-bold text-nowrap"
          }, "Concepto:", -1)),
          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.selectedQuote.concept), 1)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _cache[16] || (_cache[16] = _createElementVNode("label", {
            for: "fromAmount",
            class: "col-12 col-sm-4 col-form-label py-0 fw-bold text-nowrap overflow-hidden"
          }, "Monto:", -1)),
          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.selectedQuote.fromAmount) + " " + _toDisplayString(_ctx.selectedQuote.fromCurrency), 1)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", {
            class: _normalizeClass(["input-group justify-content-center flex-nowrap", _ctx.receivedAmountClasses])
          }, [
            _createElementVNode("div", _hoisted_25, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control rounded-0 rounded-start text-center", _ctx.receivedAmountClasses]),
                id: "amount",
                placeholder: "0.00000000",
                pattern: "^[0-9]+([.][0-9]{1,8})?$",
                maxlength: "10",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activateQuoteRequest.receivedAmount) = $event)),
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateAmount())),
                onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateAmount())),
                onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetAmountValidation())),
                disabled: !_ctx.canEditFields,
                required: ""
              }, null, 42, _hoisted_26), [
                [_vModelText, _ctx.activateQuoteRequest.receivedAmount]
              ]),
              _cache[17] || (_cache[17] = _createElementVNode("label", { for: "amount" }, "Monto del Pago", -1))
            ]),
            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.selectedQuote.paymentCurrency), 1)
          ], 2),
          _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.receivedAmountValidation.invalidMessage), 1)
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", _ctx.txHashClasses]),
              id: "hash",
              placeholder: "",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.activateQuoteRequest.txHashId) = $event)),
              onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validateTransactionHash())),
              disabled: !_ctx.canEditFields,
              required: ""
            }, null, 42, _hoisted_31), [
              [_vModelText, _ctx.activateQuoteRequest.txHashId]
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("label", { for: "amount" }, "Hash de la Transacción", -1)),
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "invalid-feedback" }, "El Hash de la transacción es incorrecto!", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              id: "notes",
              placeholder: "",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.activateQuoteRequest.notes) = $event)),
              disabled: !_ctx.canEditFields
            }, null, 8, _hoisted_34), [
              [_vModelText, _ctx.activateQuoteRequest.notes]
            ]),
            _cache[20] || (_cache[20] = _createElementVNode("label", { for: "amount" }, "Notas", -1))
          ])
        ])
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn btn-outline-success",
          disabled: !_ctx.isValid || !_ctx.update || _ctx.activating,
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.activateQuote()))
        }, [
          _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fas fa-check fa-fw me-1" }, null, -1)),
          _cache[22] || (_cache[22] = _createTextVNode("Activar ", -1)),
          (_ctx.activating)
            ? (_openBlock(), _createElementBlock("i", _hoisted_37))
            : _createCommentVNode("", true)
        ], 8, _hoisted_36)
      ])
    ])
  ]))
}